import React from "react"

export const withBreadCrumbs = Component => ({ name = "BreadCrumbs", paths, children = null, fullWidth = false }) => {
  Component.displayName = name

  return paths?.length > 0 ? <Component paths={paths} fullWidth={fullWidth}>{children}</Component> : null
}
